import { Box, Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useTheme } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../../components/Header';
import { useStore } from '../../store';
import Spinner from '../../components/Spinner';
import { tokens } from '../../theme';

const AddCategory = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery('(min-width:600px)');

  const navigate = useNavigate();

  const createCategoryApiCall = useStore((state) => state.createCategoryApi);

  const onSubmit = async (values, actions) => {
    await createCategoryApiCall(values);
    actions.resetForm();
    navigate('/categories');
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    isSubmitting,
    setFieldValue,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: checkoutSchema,
    onSubmit,
  });
  return (
    <Box m="20px">
      <Header title="CREATE CATEGORY" subtitle="Create a New Meal Category" />
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Name"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.name}
            name="name"
            error={!!touched.name && !!errors.name}
            helperText={touched.name && errors.name}
            sx={{ gridColumn: 'span 4' }}
          />
        </Box>
        <Box display="flex" justifyContent="end" mt="20px">
          <Button
            sx={{
              backgroundColor: colors.redAccent[500],
              color: '#fff',
            }}
            disabled={isSubmitting}
            type="submit"
            color="secondary"
            variant="contained"
          >
            {isSubmitting ? <Spinner color="#888" /> : `Create Category`}
          </Button>
        </Box>
      </form>
      {/* )}
        </Formik> */}
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});
const initialValues = {
  name: '',
};

export default AddCategory;
